export * from './modal.module';
export * from './components/confirm/confirm-modal.component';
export * from './components/zoom-image/zoom-image.component';
export * from './components/modal-header/modal-header.component';
export * from './components/modal-footer/modal-footer.component';
export * from './model/modal.config.model';
export * from './service/modal.service';
